const DEFAULT_CURRENCY = 'AUD';

export function formatAUD(value, currency = DEFAULT_CURRENCY) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}
